export default {
  id: null,
  pastaID: null,
  empresaID: null,
  caixaPasta: null,
  nome: null,
  justificativa: null,
  arquivo: null,
  dataEnvio: null,
  validade: null,
  status: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/documentmodel.js